/* eslint @next/next/no-img-element: "off" */
"use client";

import dynamic from "next/dynamic";
import {useState} from "react";
import PropTypes from "prop-types";
import Image from "next/image";

const DitheredImage = dynamic(() => import("@/components/gfx/DitheredImage"), {
  ssr: false,
});

const getImageURI = image => {
  if (typeof image === "string" || image instanceof String) {
    return image;
  } else if (
    (typeof image === "object" || image instanceof Object)
    && "src" in image
  ) {
    return image.src;
  }

  return String(image);
};

const ImageFigure = props => <figure {...props}>{props.children}</figure>;
const ImageDiv = props => <div {...props}>{props.children}</div>;

const MagaImage = ({
  alt = "Some unanotated image here",
  asDiv = false,
  caption,
  className,
  dithered = false,
  height,
  fullSrc,
  src,
  width,
  zoomable = true,
}) => {
  const [shown, setShown] = useState(false);
  const showFull = () => {
    if (zoomable) {
      setShown(true);
    }
  };
  const hideFull = () => setShown(false);

  const finalCaption = caption ?? alt ?? null;
  const ImageTag = asDiv ? ImageDiv : ImageFigure;

  let finalImage = <img alt={alt} src={getImageURI(src)} onClick={showFull}/>;
  if (width && height) {
    finalImage = (
      <Image alt={alt}
             height={height}
             src={getImageURI(src)}
             width={width}
             onClick={showFull}
      />
    );
  }
  if (dithered) {
    finalImage = (
      <DitheredImage alt={alt} src={getImageURI(src)} onClick={showFull}/>
    );
  }

  if (zoomable && shown) {
    return (
      <>
        <ImageTag className={className}>
          {finalImage}
        </ImageTag>
        <div className="modal is-active">
          <div className="modal-background" onClick={hideFull}></div>
          <div className="modal-content has-image" onClick={hideFull}>
            <p className="image" style={{textAlign: "center"}}>
              <img alt={alt}
                   className="big-image"
                   src={getImageURI(fullSrc ?? src)}
              />
              <br></br>
              <span className="subtitle is-5 image-caption has-text-light">
                {finalCaption}
              </span>
            </p>
          </div>
          <button className="modal-close is-large" onClick={hideFull}></button>
        </div>
      </>
    );
  }

  return <ImageTag className={className}>{finalImage}</ImageTag>;
};

MagaImage.propTypes = {
  alt: PropTypes.string,
  asDiv: PropTypes.bool,
  caption: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  className: PropTypes.string,
  fullSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  height: PropTypes.number,
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  width: PropTypes.number,
  zoomable: PropTypes.bool,
};

export default MagaImage;
